precision mediump float;

uniform vec3 color1;
uniform vec3 color2;
uniform float uTime;
uniform float seeds[4];
uniform float speeds[4];

varying vec3 vNormalEye;
varying vec3 vViewPosition;

float pulseEnvelope(float x, float center, float width, float falloff) {
    float inInner  = smoothstep(center - width, center, x);
    float outOuter = smoothstep(center, center + falloff, x);
    return inInner * (1.0 - outOuter);
}

void main() {
    vec3 N = normalize(vNormalEye);
    vec3 V = normalize(vViewPosition);
    float dotNV = max(dot(N, V), 0.0);

    float radialInv = 1.0 - dotNV;

    float base = pow(dotNV, 4.0);
    vec3 baseColor = mix(color1, color2, base);

    float pulseSum = 0.0;
    float ringWidth   = 0.04;
    float ringFalloff = 0.06;
    for (int i = 0; i < 4; i++) {
        float phase = fract(uTime * speeds[i] + seeds[i]);

        pulseSum += pulseEnvelope(radialInv, phase, ringWidth, ringFalloff);
    }
    pulseSum = (pulseSum / 4.0) * 0.15; 

    float edgeFade = pow(dotNV, 6.0);

    float alpha = clamp(base + pulseSum * edgeFade, 0.0, 1.0);
    vec3 finalColor = baseColor + pulseSum * (color2 - color1);

    gl_FragColor = vec4(finalColor, alpha);
}
